/* eslint-disable no-unused-vars */
export enum SearchTypes {
  CITY = '(cities)',
  ADDRESS = 'address',
  POSTAL_CODE = 'postal_code',
  STATE = 'administrative_area_level_1',
  SCHOOL = 'university',
}
